import { render, staticRenderFns } from "./document-item.vue?vue&type=template&id=ab42c4cc&scoped=true&"
import script from "./document-item.vue?vue&type=script&lang=js&"
export * from "./document-item.vue?vue&type=script&lang=js&"
import style0 from "./document-item.vue?vue&type=style&index=0&id=ab42c4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab42c4cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab42c4cc')) {
      api.createRecord('ab42c4cc', component.options)
    } else {
      api.reload('ab42c4cc', component.options)
    }
    module.hot.accept("./document-item.vue?vue&type=template&id=ab42c4cc&scoped=true&", function () {
      api.rerender('ab42c4cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/documents/document-item.vue"
export default component.exports